/*! Copyright © 2026 Kontextlab GmbH. All rights reserved. */

import { accessToken } from '../lib/access.js';
import { Glossary } from '../lib/glossary.js';
import { Social } from '../lib/social.js';
import { setSocial } from '../lib/map-popup.js';
import { setGlossary, setSocialPanel } from '../lib/instances.js';
import { emit } from '../lib/events.js';

/** The glossary, once loaded. The popups link terms through it. */
export let glossary = null;
/** The sharing panel, built from the map's own settings. */
export let social = null;
import { getConfig } from '../lib/config.js';
import { injectParams } from '../lib/links.js';

export function init() {
        const cfg = getConfig() ?? {};
        social = new Social(cfg.social ?? {});
    // The popups are handed the panel rather than importing one.
    setSocial(social);
    setSocialPanel(social);
        glossary = new Glossary();
    setGlossary(glossary);
        const url = injectParams(cfg.endpoints.glossary, {
            // As with the table of contents: the cookie does not travel
            // to a map embedded in another site.
            access: accessToken(),
            lang: cfg.i18n.lang,
            preview: cfg.map.isPreview ? 1 : null
        });
    // The glossary is fetched when the browser is next idle, so a popup
    // opened from the URL on first load can be built before the terms
    // arrive -- and nothing marked it up afterwards. Announcing the load
    // lets whatever is already on the page take a second pass.
    // `load` reports its own failure and resolves either way, so there
    // is nothing to announce unless terms actually arrived.
    const load = () =>
        glossary.load(url).then(() => {
            if (glossary.terms.length) {
                emit(document, 'glossary:loaded', []);
            }
        });
    'requestIdleCallback' in window
        ? requestIdleCallback(load)
        : setTimeout(load, 0);
}
